import styled from "styled-components";
import { V3Body } from "../Typography";

export const SignupAddContentAddAliasCTA = styled(V3Body)`
    display: flex;
    align-items: center;
    min-height: 18px;
    cursor: pointer;

    > div {
        display: inline-flex;

        &:first-child {
            margin-right: 6px;
        }
    }
`;

export const SignupAddContentAddAliasCTAText = styled(V3Body)`
    color: ${({ theme }) => theme.v3.colors.blue};
`;